import {
    CONFIRMED_GET_NOTE_CATEGORIES,
    CONFIRMED_CREATE_NOTE_CATEGORIES,
    CONFIRMED_DELETE_NOTE_CATEGORIES,
    CONFIRMED_EDIT_NOTE_CATEGORIES,
  } from "../types/NoteCategoriesType";
  
  
  const initialState = {
    list: [],
    num_rows: 0,
  };
  
  export default function NoteCategoryReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_NOTE_CATEGORIES:
        return {
          ...state,
          list: action.payload.list,
          num_rows: action.payload.num_rows,
        };
  
      case CONFIRMED_CREATE_NOTE_CATEGORIES:
        return {
          ...state,
          list: [...state.list, action.payload],
        };
  
      case CONFIRMED_DELETE_NOTE_CATEGORIES:
        return {
          ...state,
          list: state.list.filter(
            (item) =>
              item.noteCategory_id !== action.payload.noteCategory_id
          ),
        };
  
      case CONFIRMED_EDIT_NOTE_CATEGORIES:
        const updatedList = [...state.list];
        const index = updatedList.findIndex(
          (item) =>
            item.noteCategory_id === action.payload.noteCategory_id
        );
  
        if (index !== -1) {
          updatedList[index] = action.payload;
        }
  
        return {
          ...state,
          list: updatedList,
        };
  
      default:
        return state;
    }
  }
  